import hr from "../assets/logo.png";

export default function Terms() {
  return (
    <div className="w-full">
      <div className="max-w-2xl mx-auto mt-10">
        <img src={hr} alt="image" className="w-16 h-16" />
        <h1 className="mt-2 text-4xl font-bold">HR AI Assistant</h1>
        <p className="text-base text-neutral-400 mt-2">
          Last Updated: 2025-01-23
        </p>
        <div className="details mt-4">
          <p>
            When you use our service, you’re trusting us with important personal
            and professional information. We understand the responsibility that
            comes with handling your data and are committed to protecting your
            privacy.
          </p>
          <p className="mt-2">
            This Privacy Policy outlines the types of personal information we
            collect, how we use it, and how you can update, manage, export, and
            delete your information.
          </p>

          <h1 className="text-2xl font-bold pt-4">
            We want you to know what information we collect when you use our app
          </h1>
          <div className="subsec">
            <ul className="list-disc list-outside">
              <li className="mt-1">
                When you interact with the app, we may collect personal
                information such as your name, job title, email address, and
                other details necessary to generate HR-related notifications and
                statements.
              </li>
              <li className="ml-5 mt-1">
                As part of the services provided by the app, we assist in
                generating HR-related notifications and written statements based
                on the data you input. This data is stored within the app for
                these purposes.{" "}
              </li>
              <li className="ml-5 mt-1">
                If you choose to integrate your Google Calendar with our app, we
                will request permission to access your Google Calendar account.
                This includes the ability to:
                <ul className="list-disc list-outside">
                  <li className="ml-5 mt-2">
                    View and manage your Google Calendar events
                  </li>
                  <li className="ml-5 mt-2">Create events</li>
                  <li className="ml-5 mt-2">Fetch events</li>
                  <li className="ml-5 mt-2">Delete events</li>
                  <p className="pt-3">
                    We only use this data for calendar-related features, such as
                    voice-activated event creation.
                  </p>
                </ul>
              </li>
              <li className="ml-5 mt-1">
                Our voice-activated event creation feature requires access to
                your device’s microphone. We use this data only to process your
                voice commands and create events based on your input.
              </li>
              <li className="ml-5 mt-1">
                To access your Google Calendar, we will store authentication
                tokens securely, allowing our app to access your calendar
                without storing your password.
              </li>
              <li className="ml-5 mt-1">
                We collect data on how you use the app, including features you
                interact with, time spent, and actions taken. This helps us
                improve the user experience.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">
              We use the information we collect for the following purposes
            </h1>
            <div className="subsec ml-5">
              <ul className="list-disc list-outside">
                <li className="mt-1">
                  To provide HR-related services, including generating
                  notifications, documents, and written statements, based on
                  your input.
                </li>
                <li className="mt-1">
                  To allow you to create, list, and delete events in Google
                  Calendar through the app. This includes enabling
                  voice-activated event creation.
                </li>
                <li className="mt-1">
                  To ensure the app works as intended, improve the user
                  experience, and provide you with updates or important
                  information about the app.
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">How We Protect Your Data</h1>
            <p>
              We are committed to keeping your information secure. We use
              encryption and other security measures to protect your data from
              unauthorized access. Specific steps include:
            </p>
            <div className="subsec ml-5">
              <ul className="list-disc list-outside">
                <li className="mt-1">
                  Authentication tokens for Google Calendar are securely stored
                  and encrypted.
                </li>
                <li className="mt-1">
                  Only authorized personnel have access to your data, and we
                  take steps to ensure that your personal and HR data is handled
                  responsibly.
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Data Sharing</h1>
            <p>
              We do not share your personal information, HR-related data, or
              Google Calendar data with third parties for marketing purposes. We
              may share information in the following cases:
            </p>
            <div className="subsec ml-5">
              <ul className="list-disc list-outside">
                <li className="mt-1">
                  When required by law or to protect the rights, property, or
                  safety of our users.
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Your Rights</h1>
            <p>
              You have control over the information you share with us.
              Specifically, you can:
            </p>
            <div className="subsec ml-5">
              <ul className="list-disc list-outside">
                <li className="mt-1">
                  Access and update your personal and HR data.
                </li>
                <li className="mt-1">
                  Revoke Google Calendar access at any time through the app or
                  your Google account.
                </li>
                <li className="mt-1">
                  Request the deletion of your data by contacting our support
                  team.
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">
              Changes to This Privacy Policy{" "}
            </h1>
            <div className="subsec ml-10">
              <p className="mt-1 ">
                We may update this Privacy Policy from time to time. Any changes
                will be posted within the app, and we will include an updated
                effective date. We encourage you to review this policy
                periodically to stay informed about how we are protecting your
                data.
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer className="w-full mt-10 py-4 bg-neutral-100 text-center">
        <h1>
          All Rights Reserved{" "}
          <a href="https://thekaizenglobal.com/">Kaizen Global</a> 2025
        </h1>
      </footer>
    </div>
  );
}
